export default {
  requestVacations: [],
  requestVacation: {},
  requestVacationsFilters: {},
  requestVacationsPaginationOptions: {},
  apiResource: 'request-vacations',
  requestVacationsBadgeQTY: null
};
